// extracted by mini-css-extract-plugin
export default {"title":"styles_title__Wyc3r","section":"styles_section__loSV1","form":"styles_form__WLnY-","loaderContainer":"styles_loaderContainer__yHKZ+"};